<template>
<div class="chapter">
<div class="inner_page">
<section class="element element-container-group element-bodymatter element-type-volume element-with-heading" epub:type="volume" id="vol-1">
<div class="heading heading-with-title heading-without-image" id="vol-1-heading">
<div class="heading-contents">
<div class="title-subtitle-block title-block-without-element-number">
<div class="element-number-block">
</div>
<div class="title-block">
<h1 class="title">Gavin Funke’s Monster Movie Marathon</h1>
</div>
<h2 class="subtitle">(Bring the Whole Family!)</h2>
</div>
<div class="element-heading-author-block">
<h2 class="author">Jonathan Maberry</h2>
</div>
</div>
</div>
<div class="text" id="vol-1-text">
</div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// vol-001.vue?64c968cc